import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { ComponentService } from "../../../services/component.service";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { LocationStrategy } from "@angular/common";
import { UtilityService } from "../../../services/utility.service";
import { SharedHttp } from "../../../services/http-client.service";
import { QrScannerModalComponent } from "../../qr-scanner-modal";
import { QrScannerModalService } from "../../qr-scanner-modal/qr-scanner-modal.service";
import { WebClientService } from "../../../services/webclient-settings.service";
import { WithdrawWalletModalComponent } from "../withdraw-wallet-modal/withdraw-wallet-modal.component";
let AddAddressToWhitelistModalComponent = class AddAddressToWhitelistModalComponent {
    constructor(sanitizer, compService, themeService, location, utilityService, httpClient, qrScannerService, webSettingsService) {
        this.sanitizer = sanitizer;
        this.compService = compService;
        this.themeService = themeService;
        this.location = location;
        this.utilityService = utilityService;
        this.httpClient = httpClient;
        this.qrScannerService = qrScannerService;
        this.webSettingsService = webSettingsService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.address = '';
        this.validAddress = true;
        this.addressName = '';
        this.step = 1;
        this.sendButtonClicked = false;
        this.errorMessage = '';
        this.selectedChain = '';
        this.activeChains = false;
        this.firstName = '';
        this.firstNameError = false;
        this.lastName = '';
        this.lastNameError = false;
        this.addressLine = '';
        this.country = '';
        this.countryError = false;
        this.city = '';
        this.cityError = false;
        this.postCode = '';
        this.postCodeError = false;
        this.countriesExpanded = false;
        this.countriesDropdownInFocus = false;
        this.keyword = 'name';
        this.addressLineError = false;
        this.ownAddress = false;
        this.isCompany = false;
        this.companyName = '';
        this.companyNameError = false;
        this.companyRegistrationNumber = '';
        this.companyRegistrationNumberError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            this.userInfoMandatory = this.webSettingsService.applySettings('WALLET.WHITELIST_ADDRESS.USER_INFO_MANDATORY');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        if (this.data.selectedChain) {
            this.fillChainData(this.data.selectedChain);
        }
        if (this.userInfoMandatory) {
            this.getCountries();
        }
    }
    getCountries() {
        this.httpClient.get('user/registrationcountries').subscribe((data) => {
            this.countries = data;
        });
    }
    onFocusedCountriesDropdown(e) {
        this.countriesDropdownInFocus = e;
        this.countryError = !e && !this.country;
        return !this.countryError;
    }
    onCountriesDropdownClear(e) {
        this.country = null;
    }
    setCountry(item) {
        this.country = item.id;
    }
    checkValidation() {
        if (this.address === '') {
            this.validAddress = true;
            return;
        }
        if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
            this.utilityService.validateAddress(this.address, this.data.walletData.currency.verboseId, this.chainForOrder ? this.chainForOrder['chain']['name'] : null).then(result => {
                this.validAddress = result.validDepositAddress;
            });
        }
        else {
            this.validAddress = true;
        }
    }
    checkIfFormIsInvalid() {
        if (this.data.updateExistingAddress) {
            this.address = this.data.address.address;
            this.addressName = this.data.address.name;
        }
        const baseInvalid = !this.address ||
            !this.addressName ||
            !this.validAddress;
        if (!this.userInfoMandatory || this.ownAddress) {
            return baseInvalid;
        }
        const commonInfoInvalid = !this.addressLine || this.addressLineError ||
            !this.country || this.countryError ||
            !this.city || this.cityError ||
            !this.postCode || this.postCodeError;
        if (this.isCompany) {
            const companyInvalid = !this.companyName || this.companyNameError ||
                !this.companyRegistrationNumber || this.companyRegistrationNumberError;
            return baseInvalid || commonInfoInvalid || companyInvalid;
        }
        else {
            const individualInvalid = !this.firstName || this.firstNameError ||
                !this.lastName || this.lastNameError;
            return baseInvalid || commonInfoInvalid || individualInvalid;
        }
    }
    addAddressToWhitelist() {
        if (!this.address || !this.addressName || !this.validAddress) {
            return;
        }
        if (this.userInfoMandatory && !this.ownAddress) {
            if (this.isCompany) {
                if (!this.checkCompanyName() || !this.checkCompanyRegistrationNumber() || !this.checkAddress() || !this.onFocusedCountriesDropdown(false) || !this.checkCity() || !this.checkPostCode()) {
                    return;
                }
            }
            else {
                if (!this.checkFirstName() || !this.checkLastName() || !this.checkAddress() || !this.onFocusedCountriesDropdown(false) || !this.checkCity() || !this.checkPostCode()) {
                    return;
                }
            }
        }
        this.sendButtonClicked = true;
        const addressData = {
            newDestinationAddress: this.address,
            newDestinationAddressName: this.addressName,
            currency: this.data.walletData.currency.verboseId,
            chain: this.chainForOrder['chain']['name'],
            isCompany: this.isCompany,
        };
        if (this.ownAddress) {
            addressData['ownAddress'] = this.ownAddress;
        }
        else {
            if (this.isCompany) {
                addressData['companyName'] = this.companyName;
                addressData['companyRegistrationNumber'] = this.companyRegistrationNumber;
            }
            else {
                addressData['firstName'] = this.firstName;
                addressData['lastName'] = this.lastName;
            }
            addressData['addressLine'] = this.addressLine;
            addressData['countryId'] = this.country;
            addressData['city'] = this.city;
            addressData['postCode'] = this.postCode;
        }
        if (this.data.updateExistingAddress) {
            addressData["verboseId"] = this.data.address.verboseId;
            this.httpClient.post('wallet/updatewhitelistaddress', addressData).subscribe((data) => {
                this.sendButtonClicked = false;
                this.close();
                this.compService.openModal(WithdrawWalletModalComponent, {
                    accountData: this.data.accountData,
                    walletData: this.data.walletData
                });
            }, (error) => {
                this.sendButtonClicked = false;
                if (error.error['message']) {
                    this.errorMessage = error.error['message'];
                }
            });
        }
        else {
            this.httpClient.post('wallet/addnewaddresstowhitelist', addressData).subscribe((data) => {
                this.sendButtonClicked = false;
                this.step = 2;
            }, (error) => {
                this.sendButtonClicked = false;
                if (error.error['message']) {
                    this.errorMessage = error.error['message'];
                }
            });
        }
    }
    openQRScanner() {
        this.compService.openModal(QrScannerModalComponent, {
            enableScanner: true
        });
        this.qrScannerService.getScanResult().subscribe((result) => {
            if (typeof result !== 'undefined' && result !== null) {
                let arr;
                let address;
                if (result.indexOf(':') !== -1) {
                    arr = result.split(':');
                    address = arr[1];
                }
                else {
                    address = result;
                }
                if (address.indexOf('?') !== -1) {
                    arr = address.split('?');
                    address = arr[0];
                }
                this.address = address;
                this.qrScannerService.scanDone(null);
            }
        });
    }
    openChainsSelect() {
        this.activeChains = !this.activeChains;
    }
    fillChainData(data) {
        this.selectedChain = data.chain.name + ' - ' + data.chain.description;
        this.chainForOrder = data;
        this.activeChains = false;
        this.checkValidation();
    }
    close() {
        this.modal.destroy();
    }
    checkFirstName() {
        const regex = /^[\p{L}]+(?:[-\s][\p{L}]+)*$/u;
        this.firstNameError = !this.firstName || !regex.test(this.firstName);
        return !this.firstNameError;
    }
    checkLastName() {
        const regex = /^[\p{L}]+(?:[-\s][\p{L}]+)*$/u;
        this.lastNameError = !this.lastName || !regex.test(this.lastName);
        return !this.lastNameError;
    }
    checkAddress() {
        const regex = /^(?=.*\p{L})[\p{L}0-9\s,.\-\/'’]+$/u;
        this.addressLineError = !this.addressLine || !regex.test(this.addressLine);
        return !this.addressLineError;
    }
    checkCity() {
        this.cityError = !this.city;
        return !this.cityError;
    }
    checkPostCode() {
        this.postCodeError = !this.postCode;
        return !this.postCodeError;
    }
    checkCompanyName() {
        this.companyNameError = !this.companyName;
        return !this.companyNameError;
    }
    checkCompanyRegistrationNumber() {
        this.companyRegistrationNumberError = !this.companyRegistrationNumber;
        return !this.companyRegistrationNumberError;
    }
    setIsCompany(value) {
        if (this.ownAddress) {
            return;
        }
        this.isCompany = value;
    }
};
AddAddressToWhitelistModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: ComponentService },
    { type: WebsiteThemeService },
    { type: LocationStrategy },
    { type: UtilityService },
    { type: SharedHttp },
    { type: QrScannerModalService },
    { type: WebClientService }
];
AddAddressToWhitelistModalComponent = __decorate([
    Component({
        selector: 'ecd-add-address-to-whitelist-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./add-address-to-whitelist-modal.component.html")).default,
    })
], AddAddressToWhitelistModalComponent);
export { AddAddressToWhitelistModalComponent };
